// packages
import cx from 'classnames';
import { intcomma, pluralize } from 'journalize';
import { h } from 'preact';

export default function OtherCandidateRow({
  isViewable,
  votes,
  totalVotes,
  candidateCount,
  onClick,
}) {
  const classes = cx('candidate contest__candidate-row', {
    'contest__candidate-row--hidden': !isViewable,
  });

  return (
    <tr class={classes}>
      <td class="candidate__cell candidate__name">
        <button onClick={onClick}>
          {candidateCount} other{pluralize(candidateCount)}
          <i class="icon LATTriangleDown" />
        </button>
      </td>
      <td class="table-align-right">{intcomma(votes)}</td>
      <td class="table-align-right">
        {totalVotes <= 0 ? '0.0' : ((votes / totalVotes) * 100).toFixed(1)}
        <span class="candidate__pct-symbol">%</span>
      </td>
    </tr>
  );
}
